import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import Help from '@/components/Help'
import Statistics from '@/components/Statistics'
import Igv from '@/components/search/Igv'
import Se from '@/components/search/Se'
import En from '@/components/search/En'
import List from '@/components/search/List'
import Gokegg from '@/components/search/Gokegg'
import Feature from '@/components/search/Feature'
import Svt from '@/components/search/Svt'
import Single from '@/components/search/Single'
import Multi from '@/components/search/Multi'
import Relationship1 from '@/components/search/Relationship1'
import Relationship2 from '@/components/search/Relationship2'
import Three from '@/components/search/Three'
import Core from '@/components/search/Core'
import Target from '@/components/search/Target'
import Overlap from '@/components/analysis/Overlap'
import Closestgene from '@/components/analysis/Closestgene'
import Convertmotif from '@/components/analysis/Convertmotif'
import Number from '@/components/analysis/Number'
import Vstf from '@/components/analysis/Vstf'
import Vsgene from '@/components/analysis/Vsgene'
import Hub from '@/components/search/Hub'
import Overlaplist from '@/components/overlap/Overlaplist'
import Closestgenelist from '@/components/closestgene/Closestgenelist'
import Closestgenebedlist from '@/components/closestgene/Closestgenebedlist'
import Sepanel from '@/components/seAnalysis/Sepanel'
import Enpanel from '@/components/teAnalysis/Enpanel'
import Hubpanel from '@/components/hubAnalysis/Hubpanel'
import Tf from '@/components/home/Tf'
import Gene from '@/components/home/Gene'
import Enhancer from '@/components/home/Enhancer'
import Transitions from '@/components/home/Transitions'
import Tissue from '@/components/home/Tissue'
import Species from '@/components/home/Species'
import Stage from '@/components/home/Stage'
import Motiflist from '@/components/Convertmotif/Motiflist'
import Test from '@/components/Test'

Vue.use(Router)

export default new Router({
  routes: [
    {path:'/test', component:Test},
    {path:'/', redirect:'/home'},//redirect代表重定向
    {path:'/home', component:Home},
    {path:'/contact', component:Contact},
    {path:'/list', name: 'list', component:List},
    {path:'/gokegg', name: 'gokegg', component:Gokegg},
    {path:'/feature', name: 'feature', component:Feature},
    {path:'/svt', name: 'svt', component:Svt},
    {path:'/single', name: 'single', component:Single},
    {path:'/multi', name: 'multi', component:Multi},
    {path:'/relationship1', name: 'relationship1', component:Relationship1},
    {path:'/relationship2', name: 'relationship2', component:Relationship2},
    {path:'/3d', name: '3d', component:Three},
    {path:'/core_tf', name: 'core_tf', component:Core},
    {path:'/target_gene', name: 'target_gene', component:Target},
    {path:'/number', name: 'number', component:Number},
    {path:'/vstf', name: 'vstf', component:Vstf},
    {path:'/vsgene', name: 'vsgene', component:Vsgene},
    {path:'/help', component:Help},
    {path:'/statistics', component:Statistics},
    {path:'/igv', component:Igv},
    {path:'/Se', component:Se},
    {path:'/En', component:En},,
    {path:'/Hub', name: 'Hub', component:Hub},
    {path: '/Sepanel', name: 'Sepanel', component: Sepanel},///如果您使用了路由命名，则可以在代码的任何地方通过 $router.push({ name: 'Sepanel' }) 或 $router.push('/Sepanel') 的方式进行路由跳转。
    {path: '/Enpanel', name: 'Enpanel', component: Enpanel},
    {path: '/Hubpanel', name: 'Hubpanel', component: Hubpanel},
    {path: '/Tf', name: 'Tf', component: Tf},
    {path: '/Gene', name: 'Gene', component: Gene},
    {path: '/Enhancer', name: 'Enhancer', component: Enhancer},
    {path: '/Transitions', name: 'Transitions', component: Transitions},
    {path: '/tissue', name: 'Tissue', component: Tissue},
    // {path: '/Species', name: 'Species', component: Species},
    {path: '/Overlaplist', name: 'Overlaplist', component: Overlaplist},
    {path: '/Motiflist', name: 'Motiflist', component: Motiflist},
    {path: '/Closestgenelist', name: 'Closestgenelist', component: Closestgenelist},
    {path: '/Closestgenebedlist', name: 'Closestgenebedlist', component: Closestgenebedlist},
    {path:'/overlap', name: 'overlap', component:Overlap},
    {path:'/closestgene', name: 'closestgene', component:Closestgene},
    {path: '/convertmotif', name: 'Convertmotif', component: Convertmotif},
    {path: '/species', name: 'Species', component: Species},
    {path: '/stage', name: 'Stage', component: Stage},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js